var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import './Manager.scss';
import { Component } from 'decorators';
import { debounce } from 'data/function';
import deleteFunctionModal from '../deleteFunctionModal';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { ActionService } from '../../../../services/ActionService';
import { FunctionService } from '../../../../services/FunctionService';
import ActionsManageFunctionView from './ActionsManageFunctionView.html';
import { FunctionViewModel } from '../../../../models/viewModels/FunctionViewModel';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
let ActionsManageFunctionComponent = class ActionsManageFunctionComponent {
    static $inject = ['ngToast', 'PipelineActionService', 'PipelineFunctionService', 'BlipToastService', 'PipelineBuilderSegmentService', '$translate', 'ModalService'];
    constructor(ngToast, PipelineActionService, PipelineFunctionService, BlipToastService, PipelineBuilderSegmentService, $translate, ModalService) {
        'ngInject';
        this.ngToast = ngToast;
        this.PipelineActionService = PipelineActionService;
        this.PipelineFunctionService = PipelineFunctionService;
        this.BlipToastService = BlipToastService;
        this.PipelineBuilderSegmentService = PipelineBuilderSegmentService;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.isLoading = true;
        this.itemHeight = 70;
        this.maxHeight = 330;
        this.CREATE_FUNCTION_SCREEN = 'createFunction';
        this.MANAGE_FUNCTION_SCREEN = 'manageFunction';
        this.MAIN_SCREEN = '';
        this.onOpenEditFunction = (event) => {
            this.actions.description = event.func.functionDescription;
            this.actions.key = event.func.functionId;
            this.actions.functionName = event.func.functionName;
            this.actions.functionContent = event.func.functionContent;
            this.actions.inputVariables =
                event.func.functionParameters &&
                    event.func.functionParameters.trim() !== ''
                    ? event.func.functionParameters.split(',')
                    : [];
            this.PipelineBuilderSegmentService.trackBlockActionLibraryMoreOptions({
                Location: 'Library',
                Choice: 'Edit',
                Description: 'Quando o usuário clica em alguma opção dentro do ícone ’Mais opções’ na listagens de funções',
            });
            this.PipelineActionService.setActions(this.actions);
            this.PipelineActionService.setStatusNewFunction(false);
            this.PipelineActionService.setIsEditing(true);
            this.PipelineActionService.setState('manageFunction');
            this.setActiveComponent({ component: 'createFunction' });
        };
        this.filterFunctions = (event) => {
            this.filterFunctionName = event.detail.value;
            this.filterFunctionListByName(this.filterFunctionName);
        };
        this.filterFunctionListByName = (filter) => {
            if (filter) {
                this.filteredFunctions = this.filteredFunctions.filter(func => func.functionName.toLowerCase().includes(filter.toLowerCase()));
            }
            else {
                this.filteredFunctions = [...this.allFunctions];
            }
        };
        this.filterFunctionName = '';
        this.allFunctions = [];
        this.filteredFunctions = [];
        this.actions = this.PipelineActionService.getActions();
        this.debouncedSearch = debounce(this.filterFunctions, 500);
    }
    $onInit() {
        this.Initialize();
        const buttons = document.querySelectorAll('#copy-action');
        buttons.forEach(button => {
            button.style.display = 'none';
        });
    }
    $onDestroy() {
        const buttons = document.querySelectorAll('#copy-action');
        buttons.forEach(button => {
            button.style.display = '';
        });
    }
    async Initialize() {
        if (!this.actions) {
            this.actions = new FunctionViewModel();
        }
        try {
            this.allFunctions = await this.PipelineFunctionService.getAllFunctions();
            await new Promise(resolve => setTimeout(resolve, 1000));
            this.filteredFunctions = [...this.allFunctions];
            this.isLoading = false;
            this.PipelineActionService.setAllFunctions(this.allFunctions);
        }
        catch (e) {
            console.error(e);
            this.allFunctions = [];
            this.filteredFunctions = [...this.allFunctions];
            this.isLoading = false;
            this.PipelineActionService.setAllFunctions(this.allFunctions);
        }
    }
    getContainerHeight() {
        const visibleItemsCount = this.filteredFunctions.length;
        const height = Math.min(visibleItemsCount * this.itemHeight, this.maxHeight);
        return `${height}px`;
    }
    async showDeleteFunctionUniqueModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            await this.delete();
        }
    }
    async showDeleteFunctionMultipleModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
    }
    async handleDeleteWithId(event) {
        this.actions.key = event.func.functionId;
        this.actions.functionName = event.func.functionName;
        this.actions.functionContent = event.func.functionContent;
        this.actions.inputVariables =
            event.func.functionParameters &&
                event.func.functionParameters.trim() !== ''
                ? event.func.functionParameters.split(',')
                : [];
        this.actions.description = event.func.functionDescription;
        await this.handleDelete();
        this.Initialize();
    }
    async delete() {
        try {
            if (this.actions.key) {
                if (this.applications.length === 1) {
                    await this.deleteFunctionWithApplication(this.applications[0].applicationIdentity, this.applications[0].functionId);
                }
                await this.PipelineFunctionService.deleteFunction(this.actions.key);
                this.PipelineBuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                    Location: 'Library',
                    Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
                });
                this.BlipToastService.show('success', {
                    msg: this.$translate.instant('builder-tabs-actions.message.success.deleted'),
                    duration: 5000,
                });
            }
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.message.error.deleted'),
                duration: 5000,
            });
        }
    }
    async deleteFunctionWithApplication(applicationIdentity, functionId) {
        try {
            await this.PipelineFunctionService.deleteFunctionWithApplication(applicationIdentity, functionId);
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.message.error.deleted'),
                duration: 5000,
            });
        }
    }
    async handleDelete() {
        try {
            this.PipelineActionService.setActions(this.actions);
            const applicationsWithFunction = await this.PipelineFunctionService.getApplicationsOfAFunction(this.actions.key);
            this.applications = applicationsWithFunction;
            this.actions.applications = applicationsWithFunction;
            this.applications.forEach(application => {
                const serverUrl = window.location.origin;
                application.url = `${serverUrl}/application/detail/${application.applicationIdentity}/templates/builder/`;
            });
            this.PipelineBuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                Location: 'Library',
                Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
            });
            switch (applicationsWithFunction.length) {
                case 0:
                    await this.showDeleteFunctionUniqueModal();
                    break;
                default:
                    await this.showDeleteFunctionMultipleModal();
                    break;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    closeManager() {
        if (this.onActionDeleted) {
            this.onActionDeleted({ actions: this.actions });
        }
        this.setActiveComponent({ component: '' });
    }
    handleFilterChange(filterText) {
        const filteredActions = this.actions.inputVariables.filter((action) => action.name.toLowerCase().includes(filterText.toLowerCase()));
        this.PipelineBuilderSegmentService.trackBlockActionLibrarySearch({
            Location: 'Library',
            Description: 'Quando o usuário pesquisa algo no campo de input',
        });
        if (this.onActionChanged) {
            this.onActionChanged({ actions: filteredActions });
        }
    }
    createNewFunction() {
        this.PipelineActionService.setStatusNewFunction(true);
        this.PipelineActionService.setState('manageFunction');
        this.setActiveComponent({ component: 'createFunction' });
    }
};
ActionsManageFunctionComponent.$inject = ['ngToast', 'PipelineActionService', 'PipelineFunctionService', 'BlipToastService', 'PipelineBuilderSegmentService', '$translate', 'ModalService'];
ActionsManageFunctionComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: ActionsManageFunctionView,
        bindings: {
            actions: '<',
            onActionChanged: '&',
            onActionDeleted: '&',
            setActiveComponent: '&',
        },
    }),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof ActionService !== "undefined" && ActionService) === "function" ? _a : Object, typeof (_b = typeof FunctionService !== "undefined" && FunctionService) === "function" ? _b : Object, typeof (_c = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _c : Object, typeof (_d = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _d : Object, typeof (_f = typeof angular !== "undefined" && (_e = angular.translate) !== void 0 && _e.ITranslateService) === "function" ? _f : Object, Object])
], ActionsManageFunctionComponent);
export { ActionsManageFunctionComponent };
